import { IonIcon } from "@ionic/react";

interface EmptyStateProps {
  icon: string;
  title: string;
  description?: string;
}

export function EmptyState({ icon, title, description }: EmptyStateProps) {
  return (
    <div className="flex size-full flex-col items-center justify-center p-5">
      <div className="flex flex-col items-center justify-center gap-2">
        {/* Icon container with circular background */}
        <div className="flex items-center justify-center rounded-full bg-surface-primary p-3.5">
          <IonIcon icon={icon} className="size-[43.2px] text-brand-500" />
        </div>

        {/* Text container */}
        <div className="flex items-center justify-center">
          <p className="text-center text-lg font-semibold leading-[1.6] text-txt-primary">
            {title}
          </p>
        </div>

        {/* Optional description */}
        {description && (
          <p className="text-center text-sm leading-relaxed text-txt-secondary">{description}</p>
        )}
      </div>
    </div>
  );
}
